export default {
  userInfo: localStorage.getItem("userInfo") || {}, // 数据源，
  isAdd: false, //新增问题
  searchContent: '', //搜索的内容
  searchList: [], //搜索返回列表
  wsMsg: {}, //ws返回的信息
  ws: {}, //websocket
  shopcarnum: '0', //购物车数量
  idCollection: "", //收藏id
};